var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"votingLinks"},[_c('router-link',{staticClass:"likes",attrs:{"to":"likes"}}),_c('router-link',{staticClass:"favorites",attrs:{"to":"favorites"}}),_c('router-link',{staticClass:"dislikes",attrs:{"to":"dislikes"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }